module.exports = __webpack_public_path__ + "static/media/list31.75ecdec9.png";